export default __webpack_public_path__ + "static/media/tribal-land.d9780057.png";